var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Redirect } from 'react-router-dom';
import { Route as ReactRoute } from 'react-router-dom';
import { useRoute } from './Routing';
import { useUser } from 'components/user/UserProvider';
import { React } from 'libs/react';
import { useSession } from 'components/session/SessionProvider';
/**
 * @component Route
 * @since 1.0.0
 */
export function Route(props) {
    const { secure, require, component, render } = props, rest = __rest(props, ["secure", "require", "component", "render"]);
    const route = useRoute();
    const { user, can } = useUser();
    const { token } = useSession();
    /**
     * @function validate
     * @since 1.0.0
     * @hidden
     */
    function validate(props) {
        if (secure) {
            if (!token) {
                return React.createElement(Redirect, { to: route.gen('default.auth') });
            }
            // The user may still be loading; the API enforces permissions anyway.
            if (user && require && !can(require)) {
                return React.createElement(Redirect, { to: route.gen('unauthorized') });
            }
        }
        return component ? React.createElement(component, props) : null;
    }
    return React.createElement(ReactRoute, Object.assign({}, rest, { render: validate }));
}
